import { render, staticRenderFns } from "./CreateBarCode.vue?vue&type=template&id=35358370&scoped=true"
import script from "./CreateBarCode.vue?vue&type=script&lang=js"
export * from "./CreateBarCode.vue?vue&type=script&lang=js"
import style0 from "./CreateBarCode.vue?vue&type=style&index=0&id=35358370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35358370",
  null
  
)

export default component.exports